import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Main from './Main';
import Enter from './Enter';
import './App.scss';

function App (){
	let resultKey = null;
	const basename = process.env.REACT_APP_BASENAME;
	const setResultKey = ( id )=>{
		resultKey = id;
	}
	return (
		<React.Fragment>
			<BrowserRouter basename={basename}>
			<Switch>
				<Route exact path='/:key' render={()=><Enter setResultKey={setResultKey}/>}/>
				<Route exact path='/' render={() => <Main inputResultKey={resultKey} />}/>
			</Switch>
			</BrowserRouter>
		</React.Fragment>
	);

}

export default App;
